import React from "react";
import axios from 'axios';
import '../BillPayComponent/billPayy.css';
import $, { timers } from "jquery";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import FooterComponet from "../FooterComponent/FooterComponet";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import './merchantpayout.css';
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
import { setAmount, setCreateOrderRes, setCreteOrderReq, setMoneyTransferSurChargeAmount, setMoneyTransferTotalAmount, setOrderId, showCreateOrderResponse } from "../../redux/payout/payout.action";

const httpClient = axios.create();
class PayoutReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            amount: '',
            enableMerchantPayout: false,
            merchantDetails: '',
            retailerBalance: '',
            amount: '200',
            redirectToImageUpload: false,
            redirectToAddAccountPage: false,
            orderErrMsg: '',
            txnPass: '',
            createOrderErr: '',
            progress: ''
        }
    }

    componentDidMount() {


    }
    componentWillUnmount() {
    }

    enterAmount = (event) => {
        this.setState({
            amount: event.target.value
        })
    }

    enterPIN = (event) => {
        this.setState({
            txnPass: event.target.value
        })
    }



    validationWithRegex(value, regex) {
        console.log('validationWithRegex value=' + value + ';regex=' + regex);
        if (regex != null && regex != undefined && regex != '') {
            var re = new RegExp(regex);
            if (!re.test(value)) {

                return false;
            }
            else {

                return true;
            }
        } else {
            return true;
        }

    }

    getPayoutAvailableBalance = () => {
        this.setState({
            orderErrMsg: ''
        })
        var url = '/api/v1/account/balance/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(url + this.props.agentInfo.id, { headers }
        ).then((response) => {
            var retailerBalanceVal = response.data.balance + response.data.creditLimit -
                response.data.lien;
            this.setState({
                retailerBalance: retailerBalanceVal
            })
        }).catch(error => {


            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {
                this.setState({
                    orderErrMsg: 'Error in fetching balance'
                })
            }

            console.log(error.message);
        });
    }


    createOrderValidation = () => {
        if (this.state.txnPass != '' && this.state.txnPass != null
            // &&
            //     this.state.txnPass != '4444'
        ) {
            return true;
        } else {
            return false;
        }
    }

    createOrder = (event) => {
        event.preventDefault();
        this.setState({
            createOrderErr: '',
            orderErrMsg: ''
        })

        var createOrderValidationVal = this.createOrderValidation();

        if (createOrderValidationVal == true) {

            this.setState({
                progress: 'loading',
                orderprocessing: 'start',
                transfernowBtnBlock: false,

            });

            var header = '';
            header = {
                msgType: "CREATE_ORDER",
                src: 'merchant-payout',
                dst: 'merchant-payout',
                service: "PAYOUT",
                channel: "WHITELABEL",
                requesterId: this.props.clientRequesterId,
                requestId: uuidv4(),
                time: moment().utc(),
            }

            var transaction = '';


            transaction = {
                amount: parseFloat(parseInt(this.props.transferTotalAmount) -
                    parseInt(this.props.surcharge)).toFixed(2),
                operator: 'IMPS',
                customerId: this.props.agentInfo.id,
                mobile: this.props.agentInfo.mobile,
                operator_code: ''
            }

            var optional = new Map();
            optional.set("BENEFICIARY_ID", (this.props.merchantData.beneficiary.id == null ||
                this.props.merchantData.beneficiary.id == '') ? this.props.merchantData.beneficiary.createdBeneId :
                this.props.merchantData.beneficiary.id);
            optional.set("txnPass", this.state.txnPass)
            var createOrderRequest = '';
            createOrderRequest = {
                header: header,
                device: this.props.deviceInfo,
                transaction: transaction,
                validated: true,
                payment: "PARTNER_BALANCE",
                agentId: this.props.agentInfo.id,
                optional: Object.fromEntries(optional),
            }

            var createOrderUrl = '';
            createOrderUrl = '/api/v1/payout/order/create';


            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }

            console.log('create order req:' + JSON.stringify(createOrderRequest));

            httpClient.post(createOrderUrl, createOrderRequest, {
                timeout: 60 * 1000,
                timeoutErrorMessage: 'timeout',
                headers
            }
            ).then((response) => {
                console.log('create order response' + JSON.stringify(response.data));
                if (response.data.response.success == true) {
                    this.setState({
                        progress: 'finished',
                        orderprocessing: 'end',
                    })

                    // store.dispatch(setCreteOrderReq(createOrderRequest));
                    store.dispatch(setCreateOrderRes(response.data));
                    // store.dispatch(setMoneyTransferTotalAmount(this.state.amount));


                    var payoutTransferDetails = document.getElementById('payoutTransferDetails');
                    payoutTransferDetails.click();

                } else {
                    this.setState({
                        progress: 'finished',
                        orderprocessing: 'end',
                        transfernowBtnBlock: true,
                        orderErrMsg: response.data.response.displayMsg
                    })


                }
            }).catch(error => {
                this.setState({
                    progress: 'finished',
                    orderprocessing: 'end',
                    transfernowBtnBlock: true,

                })
                this.setState({
                    progressStatus: false
                })

                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else if (error.message.includes("timeout")) {
                    this.setState({
                        orderErrMsg: 'Request timed out.'
                    })

                } else {
                    this.setState({
                        orderErrMsg: error.message
                    })

                }
            })
        } else {
            this.setState({
                createOrderErr: 'Please enter PIN'
            })

        }
    }




    getMerchantDetails() {

        this.setState({
            orderErrMsg: ''
        })
        var url = '/api/v1/payout/connector/get-merchant-details/'
            + this.props.agentInfo.id;

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        httpClient.get(url, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            console.log(' get merchant details response' + JSON.stringify(response.data));

            if (response.data.response.msg == 'SUCCESS') {

                var tpsRspMsg = response.data.response.tpsRspMsg.toLowerCase();
                if (tpsRspMsg.includes("please upload")) {

                    this.setState({
                        redirectToImageUpload: true,
                        enableMerchantPayout: false
                    })

                } else if (tpsRspMsg.includes("unable to add account")) {
                    this.setState({
                        errorMessage: response.data.response.tpsRspMsg.replace("displayMsg:", ""),
                        enableMerchantPayout: false
                    })
                } else if (response.data.beneficiary.verified == true &&
                    response.data.beneficiary.active == true) {
                    this.setState({
                        enableMerchantPayout: true,
                        merchantDetails: response.data
                    })
                } else {
                    this.setState({
                        errorMessage: response.data.response.tpsRspMsg.replace("displayMsg:", "")
                    })
                }

            } else {
                console.log('calling add account API');
                this.setState({
                    redirectToAddAccountPage: true
                })
            }
        }).catch(error => {
            this.setState({
                errorMessage: 'Error in fetching merchant details'
            })
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else if (error.message.includes("timeout")) {
                this.setState({
                    orderErrMsg: 'Request timed out'
                })
            } else {
                this.setState({
                    orderErrMsg: 'Error in fetching merchant details'
                })
            }
        })
    }


    redirectToImageUploadPage = (event) => {
        event.preventDefault();
        var accountImageUpload = document.getElementById('accountImageUpload');
        accountImageUpload.click();

    }


    redirectToMerchabtOnboardPage = (event) => {
        event.preventDefault();
        var redirectToMerchabtOnboard = document.getElementById('redirectToMerchabtOnboard');
        redirectToMerchabtOnboard.click();

    }

    redirectToAddAccountPageAction = (event) => {
        event.preventDefault();
        var gotoAddAccountPage = document.getElementById('gotoAddAccountPage');
        gotoAddAccountPage.click();

    }




    render() {
        return (
            <div>
                <HeadeCommon />
                <Menu />
                <div class="main">
                    <Link to='/add-account'>
                        <button id="gotoAddAccountPage" hidden={true}></button>
                    </Link>
                    <Link to='/doc-upload'>
                        <button id="accountImageUpload" hidden={true}></button>
                    </Link>
                    <Link to='/merchant-onboard'>
                        <button id="redirectToMerchabtOnboard" hidden={true}></button>
                    </Link>
                    <Link to='/payout-transfer'>
                        <button id="payoutTransferDetails" hidden={true}></button>
                    </Link>


                    <div class="container-fluid">
                        <div class="head">
                            <h3>Merchant Payout</h3>
                            <div id="recenttxn">
                                <Link to='/payout-txn'>
                                    <button type="button">View History</button>
                                </Link>
                            </div>

                        </div>
                        <div class="usercard">
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4">


                                    <div class="merchant-dtls">
                                        {/* <img src="images/merchant.png" alt="Merchant" class="img-fluid"/> */}
                                        <h6>{this.props.agentInfo.kioskName.toUpperCase()}</h6>
                                        <p>RO ID: <strong>
                                            {this.props.agentInfo.id}
                                        </strong></p>
                                    </div>

                                    <div class="merchant-other-dtls">
                                        <p>Mobile Number:</p>
                                        <h6>{this.props.agentInfo.mobile
                                        }</h6>

                                        <p>Company Email ID:</p>
                                        <h6>{(this.props.agentInfo.email != '' &&
                                            this.props.agentInfo.email != null) ?
                                            this.props.agentInfo.email :
                                            "NA"
                                        }</h6>

                                        <p>Account Number:</p>
                                        <h6>{(this.props.merchantData != '' &&
                                            this.props.merchantData.beneficiary.bankAccNo != null &&
                                            this.props.merchantData.beneficiary.bankAccNo != '') ?
                                            this.props.merchantData.beneficiary.bankAccNo :
                                            "NA"
                                        }</h6>

                                    </div>
                                </div>

                                <div class="col-12 col-md-6 col-lg-8">
                                    <div class="merchant-right">
                                        <div class="merchant-bank">
                                            <h4>Merchant Payout Review</h4>
                                            <Link to='/merchant-payout'>
                                                <button class="lbbtn" type="button">Back</button>
                                            </Link>
                                            <br />
                                            <br />

                                            <div class="merchant-bank-dtls">
                                                <div class="merchant-bank-name">
                                                    <img src="images/bank-logo.png" alt="Bank " class="img-fluid" />
                                                    <h5>{this.props.merchantData.beneficiary.beneName.toUpperCase()}</h5>
                                                    <p>Ac No.: {this.props.merchantData.beneficiary.bankAccNo}</p>
                                                </div>
                                                <div class="dropdown-divider"></div>
                                                <div class="merchant-bank-name">
                                                    <h6>{this.props.merchantData.beneficiary.bankName}</h6>
                                                    <p>IFSC code: {this.props.merchantData.beneficiary.ifscCode}</p>
                                                </div>
                                                <div class="dropdown-divider"></div>

                                                <div class="merchant-pay-amount">
                                                    <p>Payout Amount: <span>₹ {parseFloat(parseInt(this.props.transferTotalAmount) -
                                                        parseInt(this.props.surcharge)).toFixed(2)}</span></p>
                                                    <p>Surcharge: <span>₹ {parseFloat(this.props.surcharge).toFixed(2)}</span></p>
                                                </div>
                                                <div class="dropdown-divider"></div>
                                                <div class="merchant-pay-amount">
                                                    <h6>Total Amount: <span>₹ {parseFloat(this.props.transferTotalAmount).toFixed(2)}</span></h6>
                                                </div>
                                            </div>

                                            <div class="payout-form">
                                                <form onSubmit={this.createOrder}>
                                                    <div class="row">
                                                        <div class="col-12 col-md-6">
                                                            <div class="formrow">
                                                                <div class="form-floating">
                                                                    <input type="password" class="form-control" placeholder="PIN"
                                                                        onChange={this.enterPIN}
                                                                        value={this.state.txnPass}
                                                                    />
                                                                    <label for="pass">Enter transaction PIN</label>
                                                                </div>
                                                                {this.state.createOrderErr != '' &&
                                                                    <div class='valid-error'>
                                                                        {this.state.createOrderErr}
                                                                    </div>}

                                                            </div>
                                                        </div>

                                                        <div class="col-12 col-md-12">
                                                            <button class="btn btn-primary mt-3" type="submit"
                                                                disabled={this.state.progress == 'loading' ? true : false}
                                                            >Pay Now</button>
                                                            {this.state.orderErrMsg != '' &&
                                                                <div class='valid-error'>
                                                                    {this.state.orderErrMsg}
                                                                </div>}
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <FooterComponet />
            </div>



        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone,
            agentInfo, token, clientRole, clientRequesterId, deviceInfo,
            customerId, bankLogoListTxt },
        payoutReduce: {
            amount, surcharge, merchantData, transferTotalAmount, createOrderReq
        } }
) => ({
    errorMessage, loginErrorMessage, phone,
    agentInfo, token, clientRole, clientRequesterId, deviceInfo,
    customerId, bankLogoListTxt, amount, surcharge, merchantData, transferTotalAmount,
});

export default connect(mapStateToProps, null)(PayoutReview);

